import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished, loadingFailed } from "@itk/typescript-utils";
import { Model_ChangePasswordPost, Model_ChangePasswordResult } from "src/backend/openapi/v1";

export enum Action {
  PostChangePasswordRequest = "@@ITK:SRC:PAGES:PROFILE:COMPONENTS:CHANGE-PASSWORD:CHANGE-PASSWORD-STORE.TS:ACTION:POSTCHANGEPASSWORDREQUEST",
  PostChangePasswordSuccess = "@@ITK:SRC:PAGES:PROFILE:COMPONENTS:CHANGE-PASSWORD:CHANGE-PASSWORD-STORE.TS:ACTION:POSTCHANGEPASSWORDSUCCESS",
  PostChangePasswordFail = "@@ITK:SRC:PAGES:PROFILE:COMPONENTS:CHANGE-PASSWORD:CHANGE-PASSWORD-STORE.TS:ACTION:POSTCHANGEPASSWORDFAIL",

  Clear = "@@ITK:SRC:PAGES:PROFILE:COMPONENTS:CHANGE-PASSWORD:CHANGE-PASSWORD-STORE.TS:ACTION:CLEAR"
}

type changePasswordState = {
  postChangePasswordState: Loading<Model_ChangePasswordResult>;
};

const initialState: changePasswordState = {
  postChangePasswordState: loadingNotStarted
};

export const changePasswordActions = {
  PostChangePasswordRequest: (data: Model_ChangePasswordPost, callback: (isSuccess: boolean) => void) => actionCreator(Action.PostChangePasswordRequest, { data, callback }),
  PostChangePasswordSuccess: (data: Model_ChangePasswordResult) => actionCreator(Action.PostChangePasswordSuccess, { data }),
  PostChangePasswordFail: () => actionCreator(Action.PostChangePasswordFail),

  clear: () => actionCreator(Action.Clear)
};

export const changePasswordReducer = (state = initialState, action: ActionReturnType<typeof changePasswordActions>): changePasswordState => {
  switch (action.type) {
    case Action.PostChangePasswordRequest:
      return { ...state, postChangePasswordState: loadingIsLoading };
    case Action.PostChangePasswordSuccess:
      return { ...state, postChangePasswordState: loadingFinished(action.payload.data) };
    case Action.PostChangePasswordFail:
      return { ...state, postChangePasswordState: loadingFailed };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
